import { diffLines } from "diff";

export type AiChange =
  | { kind: "same" | "add" | "remove"; text: string }
  /** Unchanged lines folded away, too far from any change to help read it. */
  | { kind: "skip"; lines: number };

/**
 * What an AI answer changes, line by line, keeping `context` unchanged lines around each
 * change. Empty when the answer changes nothing.
 */
export function aiChanges(before: string, after: string, context = 2): AiChange[] {
  const rows: { kind: "same" | "add" | "remove"; text: string }[] = [];
  for (const part of diffLines(before, after, { ignoreNewlineAtEof: true })) {
    const kind = part.added ? "add" : part.removed ? "remove" : "same";
    for (const text of part.value.replace(/\n$/, "").split("\n")) rows.push({ kind, text });
  }
  const shown = rows.map(() => false);
  rows.forEach((row, index) => {
    if (row.kind !== "same")
      for (let near = Math.max(0, index - context); near <= Math.min(rows.length - 1, index + context); near++)
        shown[near] = true;
  });
  if (rows.every((row) => row.kind === "same")) return [];
  const changes: AiChange[] = [];
  for (const [index, row] of rows.entries()) {
    if (shown[index]) changes.push(row);
    else {
      const last = changes.at(-1);
      if (last?.kind === "skip") last.lines++;
      else changes.push({ kind: "skip", lines: 1 });
    }
  }
  return changes;
}
